/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Create_BtnInputs */

const vi_api_keys_create_btn = /** @type {(inputs: Api_Keys_Create_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo khóa`)
};

/**

* @param {Api_Keys_Create_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_create_btn = /** @type {((inputs?: Api_Keys_Create_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Create_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_create_btn(inputs)
});